import { useCallback, useState } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { AdditionalFlow } from "@/domains/auth/constants/additionalFlow";
import { socialClubSelector } from "@/domains/auth/slice";
import useSignInPassword from "@/domains/auth/hooks/useSignInPassword.ts";
import { useAuthFlow } from "@/domains/auth/containers/context";
import AuthSocialClub from "@/domains/auth/components/AuthSocialClub";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthSignIn from "@/domains/auth/components/sign-in/AuthSignIn.tsx";

export default function AuthSignInContainer() {
  const { login, loginIsPending, loginError } = useSignInPassword();
  const { openOnly } = useAuthFlow();
  const socialClub = useAppSelector(socialClubSelector);
  const [password, setPassword] = useState<string>("");

  const onPasswordChangeHandler = useCallback((value: string) => {
    setPassword(value);
  }, []);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      login(password);
    },
    [password],
  );

  return (
    <>
      <AuthTitle>Вход в игру</AuthTitle>
      {socialClub && <AuthSocialClub socialClub={socialClub} />}
      <AuthSignIn
        password={password}
        onPasswordChange={onPasswordChangeHandler}
        pending={loginIsPending}
        onSubmit={onSubmit}
        error={loginError}
        onForgetPassword={() => openOnly(AdditionalFlow.AuthResetPassword)}
      />
    </>
  );
}
